import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type HelpState = {
  status: Requestable<null, null>; // Not interested in any sucess values or error values. Just keeping state.
};

const initialState = {
  status: getNotRequested(),
};

const reducer = (state: HelpState = initialState, action: ActionTypes) => {
  switch (action.type) {
    case ActionKeys.HELP_OPEN_CHAT:
      if (state.status.kind === 'success') return state;

      return {
        ...state,
        status: getRequesting(),
      };
    case ActionKeys.HELP_OPEN_CHAT_SUCCESS:
      return {
        ...state,
        status: getSuccess(null),
      };
    default:
      return state;
  }
};

export default reducer;
